import { EventCategory } from '@/enums/EventCategory'
import { EventStatus } from '@/enums/EventStatus'
import { EventTransparency } from '@/enums/EventTransparency'
import { v4 as uuidv4 } from 'uuid'
import { TableRecord } from './TableRecord'

export class EventRecord extends TableRecord {
  public organizerId: number | null = null
  public attendeeId: number | null = null
  public deviceId?: number | null = null
  public uuid: string = uuidv4()
  public summary: string | null = null
  public sequence: number = 0
  public status: number = EventStatus.Tentative
  public transparency: number = EventTransparency.Opaque
  public dtStart!: string
  public dtEnd!: string
  public category: EventCategory = EventCategory.FitTest
  public location!: string
}
